<template>
  <div v-if="isOpenDetailDialog" style="transition: opacity 1.0s">
    <div v-if="isLoading" :class="$style.wrapper">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <template v-else>
      <v-dialog v-model="isOpenDetailDialog" fullscreen>
        <v-card style="opacity: 1.0">
          <v-toolbar
            fixed
            flat
            dark
            height="56px"
            style="background-color: rgba(0, 0, 0, 0.7);"
          >
            <div :class="$style.toolbar">
              <v-spacer></v-spacer>
              <div :class="['headline', $style.toolbar__title]">
                {{ lang.title }}
              </div>
              <v-spacer></v-spacer>
              <v-btn
                flat
                fab
                :class="$style.toolbar__closeIcon"
                style="position: absolute;"
                @click="
                  isOpenDetailDialog = false;
                  isLoading = true;
                "
              >
                <closeIcon></closeIcon>
              </v-btn>
            </div>
          </v-toolbar>

          <v-content class="pt-5">
            <v-container
              grid-list-lg
              fluid
              :class="{ 'px-5': $vuetify.breakpoint.mdAndUp }"
            >
              <v-layout justify-center row wrap>
                <v-flex xs12 sm10 md7 lg6 xl5>
                  <div>
                    <v-flex class="text-xs-center">
                      <v-btn
                        light
                        block
                        :disabled="!currentIdentificationCode"
                        :class="[$style.btnTextStyle, 'subheading']"
                        @click="removeContents(currentIdentificationCode)"
                      >
                        <span class="pl-1"> {{ lang.remove_contents }} </span>
                      </v-btn>
                    </v-flex>
                  </div>

                  <v-divider class="my-2" />

                  <v-tabs centered grow>
                    <v-tabs-slider></v-tabs-slider>

                    <v-tab key="1" href="#starred">
                      {{ lang.select_type_starred }}
                    </v-tab>
                    <v-tab key="2" href="#mycontents">
                      {{ lang.select_type_my_contents }}
                    </v-tab>

                    <!--お気に入り作品一覧-->
                    <v-tab-item key="1" value="starred">
                      <v-card
                        v-for="(contents,
                        index) in placeableStarredContentsList"
                        :key="index"
                        class="ma-2"
                        @click="putContents(contents)"
                      >
                        <vc-share-contents-card
                          :thumbnail-image-src="contents.thumbnailImageUrl"
                          :contents-title="contents.title"
                          :creator-name="contents.clipUserHandle"
                          :is-panel="contents.isPanel"
                          :contents-size="contents.size"
                          :is-contents-public="contents.isPublic"
                          :is-contents-sensitive="contents.isSensitive"
                          :contents-url="contents.contentUrl"
                          :is-wall-edit="true"
                        ></vc-share-contents-card>
                      </v-card>
                    </v-tab-item>

                    <!--公開した作品一覧-->
                    <v-tab-item key="2" value="mycontents">
                      <v-card
                        v-for="(contents, index) in placeableMyContentsList"
                        :key="index"
                        class="pa-1"
                        @click="putContents(contents)"
                      >
                        <vc-share-contents-card
                          :thumbnail-image-src="contents.thumbnailImageUrl"
                          :contents-title="contents.title"
                          :creator-name="contents.clipUserHandle"
                          :is-panel="contents.isPanel"
                          :contents-size="contents.size"
                          :is-contents-public="contents.isPublic"
                          :is-contents-sensitive="contents.isSensitive"
                          :contents-url="contents.contentUrl"
                          :is-wall-edit="true"
                        ></vc-share-contents-card>
                      </v-card>
                    </v-tab-item>
                  </v-tabs>
                </v-flex>
              </v-layout>
            </v-container>
          </v-content>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>

<script>
import closeIcon from "./assets/close_icon.svg";

const B1_POSITION_PLACEABLE_SIZE = ["B1", "A2", "A4"];
const A2_POSITION_PLACEABLE_SIZE = ["A2", "A4"];
const A4_POSITION_PLACEABLE_SIZE = ["A4"];

export default {
  name: "vc-share-placeable-contents-list-dialog",
  components: {
    closeIcon: closeIcon
  },
  props: {
    isLoggedIn: {
      type: Boolean,
      default: false
    },
    wallViewerUrl: {
      type: String,
      default: ""
    },
    contentsInfoApiUrl: {
      type: String,
      default: ""
    },
    lang: {
      type: Object,
      default: () => {
        return {
          title: "作品を選ぶ",
          remove_contents: "作品を外す",
          select_type_starred: "お気に入り",
          select_type_my_contents: "公開した作品一覧",
          select_contents: "選択",
          select_contents_confirm_already_added:
            "すでにほかの場所に置かれています。移動しますか？",
          select_contents_confirm_already_added_yes: "OK",
          select_contents_confirm_already_added_no: "キャンセル",
          select_contents_alert_oversized_contents:
            "作品サイズが大きいためこの場所には置けません。",
          select_contents_alert_oversized_contents_accept: "OK"
        };
      }
    },
    //state
    isBusy: {
      type: Boolean,
      default: false
    },
    // actionsToProps
    showPlaceableContentsList: {
      type: Function,
      default: () => {}
    },
    putContentsOnWall: {
      type: Function,
      default: () => {}
    },
    deleteContentsOnWall: {
      type: Function,
      default: () => {}
    },
    // mutations
    setIsBusy: {
      type: Function,
      default: () => {}
    }
  },
  data: () => {
    return {
      isOpenDetailDialog: false,
      isLoading: true,
      placeableStarredContentsList: {},
      placeableMyContentsList: {},
      contentsIdentificationCode: "",
      positionIndex: 0,
      currentIdentificationCode: 0,
      type: "",
      size: "",
      placeId: null,
      renderJson: null
    };
  },
  created() {
    window.addEventListener("message", event => {
      if (event.data.event === "showPlaceableContentsList") {
        this.isOpenDetailDialog = true;
        this.$nextTick(() => {
          this.positionIndex = event.data.position_index;
          this.type = event.data.type;
          this.size = event.data.size;
          this.currentIdentificationCode = event.data.identification_code;
          if (event.data.render_json) {
            this.placeId = event.data.render_json.placeId;
            this.renderJson = JSON.stringify(event.data.render_json);
          }
          const apiParams = {
            type: this.type,
            size: this.size
          };
          this.callGetPlaceableContentsList(apiParams);
        });
      }
      if (event.data.event === "moveContents") {
        const apiParams = {
          identificationCode: event.data.identification_code,
          positionIndex: event.data.position_index,
          placeId: event.data.render_json.placeId,
          renderJson: JSON.stringify(event.data.render_json)
        };
        this.putContentsOnWall(apiParams);
      }
    });
  },
  methods: {
    callGetPlaceableContentsList(apiParams) {
      this.showPlaceableContentsList(
        Object.assign(apiParams, { target: "starred" })
      ).then(res => {
        const resStatus = res.status;
        if (resStatus !== 0) {
          return;
        }
        this.placeableStarredContentsList = res.placeableContentsList;
      });
      this.showPlaceableContentsList(
        Object.assign(apiParams, { target: "myContents" })
      ).then(res => {
        const resStatus = res.status;
        if (resStatus !== 0) {
          return;
        }
        this.placeableMyContentsList = res.placeableContentsList;
        this.$nextTick(() => {
          this.isLoading = false;
        });
      });
    },
    putContents(contents) {
      if (this.type === "panel" && !this.isPlaceable(contents)) {
        alert(this.lang.select_contents_alert_oversized_contents);
        return;
      }
      if (
        contents.isOnWall &&
        !confirm(this.lang.select_contents_confirm_already_added)
      ) {
        return;
      }
      this.setIsBusy(true);

      const apiParams = {
        identificationCode: contents.identificationCode,
        positionIndex: this.positionIndex,
        placeId: this.placeId,
        renderJson: this.renderJson
      };
      this.putContentsOnWall(apiParams).then(res => {
        if (res === 0) {
          const postMessageBody = {
            event: "editTargetPosition",
            position_index: Number(this.positionIndex),
            action: "add",
            render_json: this.renderJson,
            contents_info_api_url: JSON.parse(this.contentsInfoApiUrl)
          };
          const embeddedViewerIframeElement = document.querySelector(
            "[data-embeded-viewer]"
          ).contentWindow;
          embeddedViewerIframeElement.postMessage(
            postMessageBody,
            this.wallViewerUrl
          );
          setTimeout(() => {
            this.setIsBusy(false);
            this.isOpenDetailDialog = false;
          }, 1000);
          this.isLoading = true;
        }
      });
    },
    removeContents() {
      this.setIsBusy(true);
      const apiParams = {
        positionIndex: this.positionIndex
      };
      this.deleteContentsOnWall(apiParams).then(res => {
        if (res === 0) {
          const postMessageBody = {
            event: "editTargetPosition",
            position_index: Number(this.positionIndex),
            action: "remove"
          };
          const embeddedViewerIframeElement = document.querySelector(
            "[data-embeded-viewer]"
          ).contentWindow;
          embeddedViewerIframeElement.postMessage(
            postMessageBody,
            this.wallViewerUrl
          );
          setTimeout(() => {
            this.setIsBusy(false);
            this.isOpenDetailDialog = false;
          }, 1000);
          this.isLoading = true;
        }
      });
    },
    isPlaceable(contents) {
      switch (this.size) {
        case "B1":
        case "FULL":
          return B1_POSITION_PLACEABLE_SIZE.indexOf(contents.size) >= 0;
        case "A2":
          return A2_POSITION_PLACEABLE_SIZE.indexOf(contents.size) >= 0;
        case "A4":
          return A4_POSITION_PLACEABLE_SIZE.indexOf(contents.size) >= 0;
      }
    }
  }
};
</script>

<style module lang="scss">
.wrapper {
  position: fixed;
  background-color: white;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 300;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
}

.toolbar {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;

  &__title {
    max-width: 980px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0 32px 0 32px;
  }

  &__closeIcon {
    fill: white;
    margin: 0;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
  }
}
</style>
